/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type BuybackPledgeKindEnum = typeof BuybackPledgeKindEnum[keyof typeof BuybackPledgeKindEnum];


export const BuybackPledgeKindEnum = {
  PACKAGE: 'package',
  SHIP: 'ship',
  UPGRADE: 'upgrade',
  PAINT: 'paint',
  ADDON: 'addon',
  OTHER: 'other',
} as const;
